'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Tab = require('./Tab.css');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is the Tab component which handles the onClick event
 */
var Tab = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Tab, _Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this._onClickTab = function (event) {
      var _this$props = _this.props,
          changeTab = _this$props.changeTab,
          isDisabled = _this$props.isDisabled,
          isSelected = _this$props.isSelected,
          onClick = _this$props.onClick,
          index = _this$props.index;


      if (onClick) onClick(event);

      // Change Tab logic
      if (!isDisabled && !isSelected && changeTab) changeTab(event, index);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tab, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          isSelected = _props.isSelected,
          isDisabled = _props.isDisabled,
          index = _props.index;


      return _react2.default.createElement(
        'li',
        {
          className: (0, _classnames2.default)(className, _Tab2.default.root, (_cx = {}, (0, _defineProperty3.default)(_cx, _Tab2.default.isSelected, _Tab2.default.isSelected && isSelected), (0, _defineProperty3.default)(_cx, _Tab2.default.isDisabled, _Tab2.default.isDisabled && isDisabled), _cx)),
          onClick: this._onClickTab
        },
        children
      );
    }
  }]);
  return Tab;
}(_react.Component), _class.propTypes = {
  /** This is the props which handles the Selected Tab styles */
  isSelected: _react.PropTypes.bool,
  /** This is the props which handles the Disabled Tab styles */
  isDisabled: _react.PropTypes.bool,
  /** This is the callback which is fired upon the onclick event */
  changeTab: _react.PropTypes.func,
  onClick: _react.PropTypes.func,
  className: _react.PropTypes.string,
  children: _react.PropTypes.node
}, _temp2);
exports.default = Tab;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTabs/Tab/Tab.jsx
// module id = 658
// module chunks = 0